import { CompanyRowInfo } from "@/pages/Private/redux/list/list-companies.api";

/**
 * The company score badge shown on a Companies-tab row (PREC-4400): the C1/C2/C3 tier, or DQ for a
 * disqualified/competitor company, derived from the scoring result. Pure, so the mapping is tested
 * without rendering. Returns null when the company has no score yet (nothing to show). The tones
 * reuse the app's score palette (`score-p1/p2/p3/dq`, as `ProspectScoreBadge`).
 */
export interface CompanyScoreBadge {
	label: string;
	tone: "p1" | "p2" | "p3" | "dq" | "gray";
}

export function companyScoreBadge(score: CompanyRowInfo["score"]): CompanyScoreBadge | null {
	const result = score?.result?.trim();

	if (!result) {
		return null;
	}

	const normalized = result.toUpperCase();

	if (normalized === "1" || normalized === "C1") {
		return { label: "C1", tone: "p1" };
	}

	if (normalized === "2" || normalized === "C2") {
		return { label: "C2", tone: "p2" };
	}

	if (normalized === "3" || normalized === "C3") {
		return { label: "C3", tone: "p3" };
	}

	if (normalized === "DQ" || normalized === "DISQUALIFIED" || normalized === "COMPETITOR") {
		return { label: "DQ", tone: "dq" };
	}

	return { label: result, tone: "gray" };
}

/** The Tailwind classes for each badge tone (real tokens from the app's palette). */
export const COMPANY_SCORE_TONE_CLASS: Record<CompanyScoreBadge["tone"], string> = {
	p1: "bg-score-p1 text-white",
	p2: "bg-score-p2 text-white",
	p3: "bg-score-p3 text-white",
	dq: "bg-score-dq text-white",
	gray: "bg-gray-200 text-gray-700",
};
